import Article from '@models/helpers/Article'
import Rule from '@models/helpers/Rule'
import Unit from '@models/building/Unit'
import Room from '@models/building/Room'
import Valve from '@models/airvolumes/Valve'
import Systemselection from '@models/airvolumes/Systemselection'
import store from '@store'
import StoredArticle from '@models/articles/StoredArticle'
import StoredRoomArticle from '@models/articles/StoredRoomArticle'
import {checkControllingCombo} from "@services/articleSelection/controllingCombo";

let storeType = 'unit'

export function executeRules(storedArticle, type) {
  storeType = type

  const rules = Rule.query().where('article_id', storedArticle.article_id).get()

  let quantity = storedArticle.quantity
  if (rules.length <= 0) return quantity

  rules.sort((a, b) => {
    if (a.rule_name === 'max' || a.rule_name === 'max_article' || a.rule_name === 'min') {
      if (b.rule_name === 'max' || b.rule_name === 'max_article' || b.rule_name === 'min') {
        return ['max', 'max_article', 'min'].indexOf(a.rule_name) - ['max', 'max_article', 'min'].indexOf(b.rule_name)
      } else {
        return -1
      }
    } else {
      if (b.rule_name === 'max' || b.rule_name === 'max_article' || b.rule_name === 'min') {
        return 1
      } else {
        return 0
      }
    }
  })
  rules.every((rule) => {
    //if (storedArticle.updateMax == true && rule.rule_name != "max") return false;
    if (
      (
        rule.rule_name == 'xor' ||
        rule.rule_name == 'equal' ||
        rule.rule_name == 'set'
      ) &&
      storedArticle.quantity == 0
    ) {
      return false
    }
    switch (rule.rule_name) {
      case 'max':
        storedArticle.quantity = checkMax(storedArticle, rule)
        break
      case 'max_article':
        storedArticle.quantity = checkMaxArticle(storedArticle, rule)
        break
      case 'min':
        storedArticle.quantity = checkMin(storedArticle, rule)
        break
      case 'xor':
        setOr(storedArticle, rule)
        break
      case 'equal':
        setEqual(storedArticle, rule)
        break
      case 'set':
        setSet(storedArticle, rule)
        break
    }
    return true
  })

  return storedArticle.quantity
}

export function resetRules(storedArticle, type) {
  storeType = type
  const rules = Rule.query().where('article_id', storedArticle.article_id).get()
  let quantity = storedArticle.quantity
  if (rules.length <= 0) return quantity

  rules.forEach((rule) => {
    if (storedArticle.updateMax == true && rule.rule_name != 'max') return
    switch (rule.rule_name) {
      case 'min':
        quantity = checkMin(storedArticle, rule)
        break
      case 'reset':
        setSet(storedArticle, rule)
        break
      case 'set':
        unSet(storedArticle, rule)
        break
      case 'max_article':
        quantity = checkMaxArticle(storedArticle, rule)
        break
    }
  })

  return quantity
}

function checkMax(storedArticle, rule) {
  if (rule.json && rule.json.ltms) {
    // check if unit ventilationMeasure is in rule.json.ltms
    const unit = Unit.find(storedArticle.unit_id)
    if (!unit) return storedArticle.quantity
    if (!rule.json.ltms.includes(unit.ventilationMeasure)) return storedArticle.quantity
  }

  if (rule.json && rule.json.condition) {
    switch (rule.json.condition) {
      case 'anschluss':
        if (storedArticle.unit_id) {
          rule.value = anschlussCondition(rule, storedArticle.unit_id)
        }
        break
      case 'valve':
        if (storedArticle.room_id) {
          const room = Room.find(storedArticle.room_id)
          const max = valveCondition(rule, room)
          if (max > storedArticle.quantity) return storedArticle.quantity
          else return max
        }
        break
      case 'ec45Device':
        if (storedArticle.room_id) {
          const max = ec45DeviceCondition(rule, storedArticle.room_id)
          if (max > storedArticle.quantity) return storedArticle.quantity
          else return max
        }
        break
      case 'ec60Device':
        if (storedArticle.room_id) {
          const max = ec60DeviceCondition(rule, storedArticle.room_id)
          if (max > storedArticle.quantity) return storedArticle.quantity
          else return max
        }
        break
      case 'ec45':
      case 'ec60':
        if (storedArticle.room_id) {
          const room = Room.find(storedArticle.room_id)
          const max = roomDeviceConditions(rule, room)
          if (max > storedArticle.quantity) return storedArticle.quantity
          return max
        }
        break
      case 'controllingCombo':
        if (storedArticle.unit_id) {
          if (storedArticle.article_id == 505 && storedArticle.accessorygroup_id == 105) var max = 8
          else var max = controllingComboCondition(rule, storedArticle.unit_id)
          // check if article has connected articles
          let quantity = storedArticle.quantity
          if (rule.json.articles && rule.json.articles.length > 0) {
            rule.json.articles.forEach((articleId) => {
              let article = Article.query().where('id', articleId).first()
              if (!article) return
              // load stored connected articles with StoredArticle if storedArticle has unit_id else StoredRoomArticle
              let storedConnectedArticle = getStoredArticle(articleId, storedArticle.getStoreId(), article.getAccessorygroupId([storedArticle.accessorygroup_id]), true)
              if (!storedConnectedArticle) return
              if (quantity + storedConnectedArticle.quantity <= max) {
                quantity += storedConnectedArticle.quantity
                return
              }
              let connectedQuantity = 0
              if (max - quantity >= 0) {
                connectedQuantity = max - quantity
              }
              storedConnectedArticle.quantity = connectedQuantity
              storedConnectedArticle.isUpdated = true
              storedConnectedArticle.$save()
            })
          }
          if (max > quantity) return storedArticle.quantity
          return max
        }
        break
    }
  }

  let quantity = storedArticle.quantity
  if (rule.json && rule.json.articles && rule.json.articles.length > 0) {
    rule.json.articles.forEach((articleId) => {
      let article = Article.query().where('id', articleId).with(['accessorygroup']).first()
      if (!article) return
      let storedConnectedArticle = getStoredArticle(articleId, storedArticle.getStoreId(), article.getAccessorygroupId([storedArticle.accessorygroup_id]), true)
      if (!storedConnectedArticle) return
      if (quantity + storedConnectedArticle.quantity <= rule.value) {
        quantity += storedConnectedArticle.quantity
        return
      }
      let connectedQuantity = 0
      if (rule.value - quantity >= 0) {
        connectedQuantity = rule.value - quantity
      } else {
        connectedQuantity = 0
      }
      storedConnectedArticle.quantity = connectedQuantity
      storedConnectedArticle.isUpdated = true
      storedConnectedArticle.$save()
    })
  }
  if (quantity > rule.value) {
    return rule.value
  } else {
    return storedArticle.quantity
  }
}

export function checkMin(storedArticle, rule) {
  if (rule.json && rule.json.article) {
    let article = Article.query().where('id', rule.json.article).with(['accessorygroup']).first()
    if (!article) return 0
    let connectedArticle
    if (storedArticle.unit_id) {
      connectedArticle = StoredArticle.query()
        .where('article_id', rule.json.article)
        .where('unit_id', storedArticle.unit_id)
        .where('accessorygroup_id', article.getAccessorygroupId([storedArticle.accessorygroup_id]))
        .first()
    } else {
      connectedArticle = StoredRoomArticle.query()
        .where('article_id', rule.json.article)
        .where('room_id', storedArticle.room_id)
        .where('accessorygroup_id', article.getAccessorygroupId([storedArticle.accessorygroup_id]))
        .first()
    }
    if (!connectedArticle) return 0
    if (connectedArticle.quantity > storedArticle.quantity) return connectedArticle.quantity
  }
  if (rule.json && rule.json.condition) {
    switch (rule.json.condition) {
      case 'ec60':
      case 'ec45':
        const room = Room.find(storedArticle.room_id)
        const min = roomQuantityConditions(rule, room)
        if (min < storedArticle.quantity) return storedArticle.quantity
        return min
      case 'controllingCombo':
        if (storedArticle.unit_id != null) {
          const min = controllingComboCondition(rule, storedArticle.unit_id)
          if (min < storedArticle.quantity) return storedArticle.quantity
          return min
        }
        break
    }
  }
  if (rule.value > storedArticle.quantity) return rule.value
  return storedArticle.quantity
}

function checkMaxArticle(storedArticle, rule) {
  let quantity = storedArticle.quantity
  if (rule.json && rule.json.ltms) {
    // check if unit ventilationMeasure is in rule.json.ltms
    const unit = Unit.find(storedArticle.unit_id)
    if (!unit) return quantity
    if (!rule.json.ltms.includes(unit.ventilationMeasure)) return quantity
  }

  if (rule.json && rule.json.children && rule.json.children.length > 0) {
    rule.json.children.forEach((child) => {
      let article = Article.query().where('id', child).first()

      if (!article) return
      let storedConnectedArticle = getStoredArticle(child, storedArticle.getStoreId(), article.getAccessorygroupId([storedArticle.accessorygroup_id]), true)
      if (!storedConnectedArticle) {
        return
        // generat new storedArticle or storedRoomArticle
        /*                 if (storedArticle.unit_id) {
            storedConnectedArticle = new StoredArticle();
            storedConnectedArticle.unit_id = storedArticle.unit_id;
        } else {
            storedConnectedArticle = new StoredRoomArticle();
            storedConnectedArticle.room_id = storedArticle.room_id;
        }
        storedConnectedArticle.article_id = child;
        storedConnectedArticle.accessorygroup_id = article.getAccessorygroupId([storedArticle.accessorygroup_id]); */
      }

      if (quantity < storedConnectedArticle.quantity) {
        storedConnectedArticle.quantity = quantity
        storedConnectedArticle.$save()
      }
    })
  }

  if (!rule.json || !rule.json.articles || rule.json.articles.length <= 0) return quantity
  let connectedQuantity = 0
  rule.json.articles.forEach((articleId) => {
    let article = Article.query().where('id', articleId).first()
    if (!article) return
    let storedConnectedArticle = getStoredArticle(articleId, storedArticle.getStoreId(), article.getAccessorygroupId([storedArticle.accessorygroup_id]))

    if (!storedConnectedArticle) {
      return
    }
    if (connectedQuantity < storedConnectedArticle.quantity) {
      connectedQuantity = storedConnectedArticle.quantity
    }
  })
  if (quantity > connectedQuantity) {
    quantity = connectedQuantity
  }
  return quantity
}

function setOr(storedArticle, rule) {
  if (!rule.json || !rule.json.articles || rule.json.articles.length <= 0) return

  rule.json.articles.forEach((articleId) => {
    let article = Article.query().where('id', articleId).first()
    if (!article) return

    let storedConnectedArticle = getStoredArticle(articleId, storedArticle.getStoreId(), article.getAccessorygroupId([storedArticle.accessorygroup_id]), true)
    if (!storedConnectedArticle) return

    storedConnectedArticle.$delete()
  })
}

function setEqual(storedArticle, rule) {
  if (!rule.json || !rule.json.articles || rule.json.articles.length <= 0) return
  rule.json.articles.forEach((articleId) => {
    let article = Article.query().where('id', articleId).first()
    if (!article) return

    let storedConnectedArticle = getStoredArticle(articleId, storedArticle.getStoreId(), article.getAccessorygroupId([storedArticle.accessorygroup_id]))
    if (!storedConnectedArticle) {
      // generate new storedArticle or storedRoomArticle
      if (storedArticle.unit_id) {
        storedConnectedArticle = new StoredArticle()
        storedConnectedArticle.unit_id = storedArticle.unit_id
      } else {
        storedConnectedArticle = new StoredRoomArticle()
        storedConnectedArticle.room_id = storedArticle.room_id
      }
      storedConnectedArticle.article_id = articleId
      storedConnectedArticle.accessorygroup_id = article.getAccessorygroupId([storedArticle.accessorygroup_id])
    }
    storedConnectedArticle.quantity = storedArticle.quantity
    storedConnectedArticle.$save()
  })
}

function setSet(storedArticle, rule) {
  if (!rule.json) return
  if (rule.json.condition) {
    if (rule.json.condition == 'isopipe') {
      setIsopipe(storedArticle, rule)
      return
    }
    if (rule.json.condition == 'arz') {
      setArz(storedArticle, rule)
      return
    }
    if (rule.json.condition == 'pipeEquipment') {
      const quantity = pipeEquipmentCondition(rule, storedArticle.unit_id, storedArticle)
      // set quantity of rule.json.article article in storedArticle if article not exists create new storedArticle
      let article = StoredArticle.query().where('article_id', rule.json.article).where('unit_id', storedArticle.unit_id).first()
      if (!article) {
        article = new StoredArticle()
        article.unit_id = storedArticle.unit_id
        article.article_id = rule.json.article
        article.accessorygroup_id = 19
      }
      article.quantity = quantity
      article.$save()
      return
    }
  }

  if (!rule.json.articles || rule.json.articles.length <= 0) return
  rule.json.articles.forEach((ruleArticle) => {
    let article = Article.query().where('id', ruleArticle.id).first()
    if (!article) return

    let storedConnectedArticle = getStoredArticle(ruleArticle.id, storedArticle.getStoreId(), article.getAccessorygroupId([storedArticle.accessorygroup_id]))
    if (!storedConnectedArticle) {
      // generate new storedArticle or storedRoomArticle
      if (storedArticle.unit_id) {
        storedConnectedArticle = new StoredArticle()
        storedConnectedArticle.unit_id = storedArticle.unit_id
      } else {
        storedConnectedArticle = new StoredRoomArticle()
        storedConnectedArticle.room_id = storedArticle.room_id
      }
      storedConnectedArticle.article_id = ruleArticle.id
      storedConnectedArticle.accessorygroup_id = article.getAccessorygroupId([storedArticle.accessorygroup_id])
    }
    if (ruleArticle.condition) {
      if (ruleArticle.condition == 'ovalPipes') {
        const unit = Unit.query().where('id', storedArticle.unit_id).first()
        const pipes = unit.getPipesAmmount()
        ruleArticle.value = pipes.totalPipes.oval
      }
      if (ruleArticle.condition == 'distributorEquipment') {
        const device = StoredArticle.query()
          .where('unit_id', storedArticle.unit_id)
          .where('accessorygroup_id', 1)
          .where('quantity', (quantity) => quantity >= 1)
          .with(['article.features'])
          .first()

        if (!device) return
        var dn = device.article.getFeatureValueById(5)
        if (!dn) return
        let article = Article.query().where('id', ruleArticle.id).with(['features']).first()
        if (!article) return
        if (article.checkFeatureValue(5, dn)) {
          ruleArticle.value = 1
        } else {
          ruleArticle.value = 0
        }
      }
      if (ruleArticle.condition == 'deviceDn') {
        const device = StoredArticle.query()
          .where('unit_id', storedArticle.unit_id)
          .where('accessorygroup_id', 1)
          .where('quantity', (quantity) => quantity >= 1)
          .with(['article.features'])
          .first()
        if (!device) return
        var dn = device.article.getFeatureValueById(5)
        if (!dn || dn != ruleArticle.dn) return
        const articles = StoredArticle.query().where('unit_id', storedArticle.unit_id).where(article => {
          return (article.article_id == 2528 || article.article_id == 2529)
        }).get();

        let quantity = 0;
        articles.forEach(article => {
          if (article['$id'] == storedArticle['$id']) {
            quantity += storedArticle.quantity
          } else {
            quantity += article.quantity
          }

        })
        ruleArticle.value = quantity
      }
      if (ruleArticle.condition == 'controllingCombo') {
        ruleArticle.value = controllingComboCondition(rule, storedArticle.unit_id)
      }
      // rule for els equipment
      if (ruleArticle.condition === 'mountingPosition') {
        // get Room
        const room = Room.query().where('id', storedArticle.room_id).first()
        // check if room is set and has mountingPosition
        if (!room || !room.mountingPosition) return
        // check if room.mountingPosition is equal to ruleArticle.position
        if (room.mountingPosition != ruleArticle.position) return
      }
    }
    storedConnectedArticle.quantity = ruleArticle.value
    storedConnectedArticle.$save()
  })
}

function unSet(storedArticle, rule) {
  if (!rule.json) return
  if (rule.json.condition) {
    if (rule.json.condition == 'isopipe') {
      setIsopipe(storedArticle, rule, true)
      return
    }
    if (rule.json.condition == 'arz') {
      setArz(storedArticle, rule)
      return
    }
    if (rule.json.condition == 'pipeEquipment') {
      const quantity = pipeEquipmentCondition(rule, storedArticle.unit_id, storedArticle)
      // set quantity of rule.json.article article in storedArticle if article not exists create new storedArticle
      let article = StoredArticle.query().where('article_id', rule.json.article).where('unit_id', storedArticle.unit_id).first()
      if (!article) {
        article = new StoredArticle()
        article.unit_id = storedArticle.unit_id
        article.article_id = rule.json.article
        article.accessorygroup_id = 19
      }
      article.quantity = quantity
      article.$save()
      return
    }
  }
  if (!rule.json.articles || rule.json.articles.length <= 0) return

  rule.json.articles.forEach((ruleArticle) => {
    //except controllingCombo
    if (ruleArticle.condition && ruleArticle.condition == 'controllingCombo') return

    let article = Article.query().where('id', ruleArticle.id).first()
    if (!article) return
    let storedConnectedArticle = getStoredArticle(ruleArticle.id, storedArticle.getStoreId(), article.getAccessorygroupId([storedArticle.accessorygroup_id]))
    if (!storedConnectedArticle) return

    storedConnectedArticle.quantity = 0
    storedConnectedArticle.$save()
  })
}

function setIsopipe(storedArticle, rule, unset = false) {
  // find storedArticle with unit_id and accessorygroup_id 22 and article_id is in rule.json.articles
  const storedArticlesIso = StoredArticle.query()
    .where('unit_id', storedArticle.unit_id)
    .where('accessorygroup_id', 22)
    .where('article_id', (articleId) => rule.json.articles.includes(articleId))
    .get();
  // delete storedArticlesIso
  storedArticlesIso.forEach((storedArticleIso) => {
    storedArticleIso.$delete()
  })
  let dn = null
  let dnDistributors = []
  // get device and all distrubutors (16,17) from unit
  const device = StoredArticle.query()
    .where('unit_id', storedArticle.unit_id)
    .where('accessorygroup_id', 1)
    .where('quantity', (quantity) => quantity >= 1)
    .with(['article.features'])
    .first()
  if (!device) return
  let distributors = StoredArticle.query()
    .where('unit_id', storedArticle.unit_id)
    .where('accessorygroup_id', (accessorygroup) => accessorygroup == 16 || accessorygroup == 17)
    .where('quantity', (quantity) => quantity >= 1)
    .with(['article.features'])
    .get()
  // add article.features to storedArticle
  const article = Article.query().where('id', storedArticle.article_id).with(['features']).first()
  if (!article) return
  storedArticle.article = article
  // add storedArticle to distributors
  if (!unset) {
    distributors.push(storedArticle)
  } else {
    distributors = distributors.filter((distributor) => distributor.id != storedArticle.id)
  }
  if (distributors.length <= 0) return
  // get dn from device
  dn = device.article.getFeatureValueById(5)
  if (!dn) return
  // get value of feature 28 of every distributor
  distributors.forEach((distributor) => {
    const dnDistributor = distributor.article.getFeatureValueById(28)
    if (dnDistributor && dn != dnDistributor) dnDistributors.push(dnDistributor)
  })
  // if dnDistributors is empty return
  if (dnDistributors.length <= 0) return
  // for each dnDistributors find an article from the rules.json.articles array that has the value == dnDistributor at feature id 28
  let articles = Article.query()
    .whereIdIn(rule.json.articles)
    .with(['features'])
    .get()
  if (articles.length <= 0) return

  // filter articles by feature 29 value == dn
  articles = articles.filter((article) => article.getFeatureValueById(29) == dn)
  if (articles.length <= 0) return
  // count same dnDistributor in dnDistributors and create sortDnDistributors array [{dnDistributor: 1, count: 2}, {dnDistributor: 2, count: 1}]
  // sortDnDistributors contains only unique dnDistributors
  let sortDnDistributors = []
  dnDistributors.forEach((dnDistributor) => {
    let foundDnDistributor = sortDnDistributors.find((sortDnDistributor) => sortDnDistributor.dnDistributor == dnDistributor)
    if (foundDnDistributor) {
      foundDnDistributor.count++
    } else {
      sortDnDistributors.push({dnDistributor: dnDistributor, count: 1})
    }
  })
  // create new storedArticle for every dnDistributor in sortDnDistributors
  sortDnDistributors.forEach((sortDnDistributor) => {
    // find article with dnDistributor at feature 28
    const article = articles.find((article) => article.checkFeatureValue(28, sortDnDistributor.dnDistributor))
    if (!article) return
    // create new storedArticle
    const storedArticleIso = new StoredArticle()
    storedArticleIso.unit_id = storedArticle.unit_id
    storedArticleIso.article_id = article.id
    storedArticleIso.accessorygroup_id = 22
    storedArticleIso.quantity = sortDnDistributor.count
    storedArticleIso.$save()
  })
  return;
}

function setArz(storedArticle, rule) {
  // delete all selected arz articles by rule.json.articles from storedArticle
  const storedArticlesArz = StoredArticle.query()
    .where('unit_id', storedArticle.unit_id)
    .where('accessorygroup_id', 22)
    .where('article_id', (articleId) => rule.json.articles.includes(articleId))
    .get()

  storedArticlesArz.forEach((storedArticleArz) => {
    storedArticleArz.$delete()
  })

  // get device dn
  const device = StoredArticle.query()
    .where('unit_id', storedArticle.unit_id)
    .where('accessorygroup_id', 1)
    .where('quantity', (quantity) => quantity >= 1)
    .with(['article.features'])
    .first()
  if (!device) return

  const dn = device.article.getFeatureValueById(5)

  // get all dn of distributors
  const dnDistributors = {
    125: 0,
    160: 0,
    180: 0,
  }

  const distributors = StoredArticle.query()
    .where('unit_id', storedArticle.unit_id)
    .where('accessorygroup_id', (accessorygroup) => accessorygroup == 16 || accessorygroup == 17)
    .where('quantity', (quantity) => quantity >= 1)
    .with(['article.features'])
    .get()

  let setStoredArticle = false
  distributors.forEach((distributor) => {
    // if distributer article id is storedArticle.article_id => set distributor quantity to storedArticle.quantity
    if (distributor.article_id == storedArticle.article_id && distributor.accessorygroup_id == storedArticle.accessorygroup_id) {
      distributor.quantity = storedArticle.quantity
      setStoredArticle = true
    }
    const dnDistributor = distributor.article.getFeatureValueById(28)
    if (dnDistributor) dnDistributors[dnDistributor] += distributor.quantity
  })

  // if storedArticle is not set get it from articles with feature, get dn (28) of article and add quantity to dnDistributors
  if (!setStoredArticle) {
    const article = Article.query().where('id', storedArticle.article_id).with(['features']).first()
    if (!article) return
    const dnArticle = article.getFeatureValueById(28)
    if (dnArticle) dnDistributors[dnArticle] += storedArticle.quantity
  }

  // if device dn 125 and dnDistributor[160] > 0 store 724 with quantity = dnDistributors[160] and accessoygroup_id 22
  // if device dn 125 and dnDistributor[180] > 0 store 726 with quantity = dnDistributors[180] and accessoygroup_id 22
  // if device dn 160 and dnDistributor[125] > 0 store 783 with quantity = dnDistributors[125] and accessoygroup_id 22
  // if device dn 160 and dnDistributor[180] > 0 store 780 with quantity = dnDistributors[180] and accessoygroup_id 22
  switch (dn) {
    case 125:
      if (dnDistributors[160] > 0) {
        const storedArticleArz = new StoredArticle()
        storedArticleArz.unit_id = storedArticle.unit_id
        storedArticleArz.article_id = 724
        storedArticleArz.accessorygroup_id = 22
        storedArticleArz.quantity = dnDistributors[160]
        storedArticleArz.$save()
      }
      if (dnDistributors[180] > 0) {
        const storedArticleArz = new StoredArticle()
        storedArticleArz.unit_id = storedArticle.unit_id
        storedArticleArz.article_id = 726
        storedArticleArz.accessorygroup_id = 22
        storedArticleArz.quantity = dnDistributors[180]
        storedArticleArz.$save()
      }
      break
    case 160:
      if (dnDistributors[125] > 0) {
        const storedArticleArz = new StoredArticle()
        storedArticleArz.unit_id = storedArticle.unit_id
        storedArticleArz.article_id = 783
        storedArticleArz.accessorygroup_id = 22
        storedArticleArz.quantity = dnDistributors[125]
        storedArticleArz.$save()
      }
      if (dnDistributors[180] > 0) {
        const storedArticleArz = new StoredArticle()
        storedArticleArz.unit_id = storedArticle.unit_id
        storedArticleArz.article_id = 780
        storedArticleArz.accessorygroup_id = 22
        storedArticleArz.quantity = dnDistributors[180]
        storedArticleArz.$save()
      }
      break
  }
}

export function getQuantity(rule, unitId, accessorygroupId) {
  if (!rule.json) {
    return rule.value
  }
  if (rule.json.article) {
    let article = Article.query().where('id', rule.json.article).with(['accessorygroup']).first()
    if (!article) return 0
    const connectedArticle = StoredArticle.query()
      .where('article_id', rule.json.article)
      .where('unit_id', unitId)
      .where('accessorygroup_id', article.getAccessorygroupId([accessorygroupId]))
      .first()
    if (!connectedArticle) return 0
    return connectedArticle.quantity
  }
  if (rule.json.condition) {
    return quantityConditions(rule, unitId, accessorygroupId)
  }
  if (rule.json.ltms) {
    const unit = Unit.find(unitId)
    if (!unit) return 0
    if (rule.json.ltms.includes(unit.ventilationMeasure)) return rule.value
  }
  return 0
}

function quantityConditions(rule, unitId, accessorygroupId) {
  switch (rule.json.condition) {
    case 'distributor':
      return distributorCondition(rule, unitId, accessorygroupId)
    case 'pipeEquipment':
      return pipeEquipmentCondition(rule, unitId)
    case 'pipe':
      return pipeCondition(rule, unitId)
    case 'ovalPipes':
      return ovalPipesCondition(rule, unitId)
    case 'anschluss':
      return anschlussCondition(rule, unitId)
    case 'isopipe':
      return isopipeCondition(rule, unitId)
  }
}

function distributorCondition(rule, unitId, accessorygroupId) {
  const unit = Unit.find(unitId)
  if (!unit) return 0
  const distributorSelections = unit.distributorSelection(accessorygroupId)
  let quantity = 0
  distributorSelections.forEach((distributorSelection) => {
    const foundFeature = rule.json.features.find((feature) => feature.value === distributorSelection.profile && feature.from < distributorSelection.pipes && feature.to >= distributorSelection.pipes)
    if (!foundFeature) {
      return
    }
    quantity += foundFeature.multiplier
  })
  return quantity
}

function pipeEquipmentCondition(rule, unitId, storedArticle = null) {
  const unit = Unit.find(unitId)
  if (!unit) return 0
  const pipes = unit.getPipesAmmount()
  let quantity = pipes.totalPipes.oval + pipes.totalPipes.round

  rule.json.articles.forEach((ruleArticle) => {
    if (storedArticle != null && storedArticle.article_id == ruleArticle) {
      quantity += storedArticle.quantity
      return
    }
    const article = Article.query().where('id', ruleArticle).with(['accessorygroup']).first()
    if (!article) return
    const connectedArticle = StoredArticle.query().where('article_id', ruleArticle).where('unit_id', unitId).where('accessorygroup_id', article.accessorygroup.accessorygroups_id).first()
    if (!connectedArticle) return
    quantity += connectedArticle.quantity
  })

  quantity = Math.ceil(quantity * 2 / 10)
  return quantity
}

function pipeCondition(rule, unitId) {
  const unit = Unit.find(unitId)
  if (!unit) return 0
  const pipes = unit.getPipesAmmount()
  const pipeProfile = unit.getPipeProfile()

  let quantity = 0

  rule.json.features.forEach((feature) => {
    if (feature.value == 63 && pipeProfile == 63) {
      quantity = Math.ceil((pipes.totalPipes.round * 10) / 50)
    } else if ((feature.value == 51 && pipeProfile == 51) || pipeProfile == 'mixed') {
      quantity = Math.ceil((pipes.totalPipes.oval * 10) / 20)
    } else if ((feature.value == 75 && pipeProfile == 75) || pipeProfile == 'mixed') {
      quantity = Math.ceil((pipes.totalPipes.round * 10) / 50)
    }
  })
  return quantity
}

function ovalPipesCondition(rule, unitId) {
  const unit = Unit.find(unitId)
  if (!unit) return 0
  const pipes = unit.getPipesAmmount()
  const pipeProfile = unit.getPipeProfile()
  let quantity = 0
  if ((pipeProfile != 51 && pipeProfile != 'mixed') || pipes.totalPipes.oval <= 0) return quantity

  if (pipes.exhaustPipes.oval > 0) {
    let storedConnectedArticle = StoredArticle.query()
      .where('unit_id', unitId)
      .where('accessorygroup_id', 17)
      .where('quantity', (quantity) => quantity >= 1)
      .with(['article.features'])
      .first()
    if (storedConnectedArticle && storedConnectedArticle.article.checkFeatureValue(12, 75)) {
      quantity = pipes.exhaustPipes.oval
    }
  }

  if (pipes.supplyPipes.oval > 0) {
    let storedConnectedArticle = StoredArticle.query()
      .where('unit_id', unitId)
      .where('accessorygroup_id', 16)
      .where('quantity', (quantity) => quantity >= 1)
      .with(['article.features'])
      .first()
    if (storedConnectedArticle && storedConnectedArticle.article.checkFeatureValue(12, 75)) {
      quantity += pipes.supplyPipes.oval
    }
  }
  return quantity
}

function anschlussCondition(rule, unitId) {
  const unit = Unit.query().where('id', unitId).with(['installation']).first()
  if (!unit) return 0

  let quantity = 0
  if (rule.json.features) {
    rule.json.features.forEach((feature) => {
      if (feature.value != unit.installation.getAnschlussType()) return
      const article = Article.query().where('id', rule.article_id).with(['features']).first()
      if (!article) return
      if (article.features.some((articleFeature) => articleFeature.feature_id == feature.id && articleFeature.value == feature.value)) quantity = feature.quantity
    })
  }
  return quantity
}

function isopipeCondition(rule, unitId) {
  // get unit device dn and feature 28 of all selected distributors (16,17)
  const device = StoredArticle.query()
    .where('unit_id', unitId)
    .where('accessorygroup_id', 1)
    .where('quantity', (quantity) => quantity >= 1)
    .with(['article.features'])
    .first()
  if (!device) return 0
  const dn = device.article.getFeatureValueById(5)
  let distributors = StoredArticle.query()
    .where('unit_id', unitId)
    .where('accessorygroup_id', (accessorygroup) => accessorygroup == 16 || accessorygroup == 17)
    .where('quantity', (quantity) => quantity >= 1)
    .with(['article.features'])
    .get()

  if (distributors.length <= 0) return 0

  const dnDistributors = {
    125: 0,
    160: 0,
    180: 0,
  }
  // get feature 28 of every distributor and count how often it occurs in dnDistributors
  distributors.forEach(distributor => {
    const dnDistributor = distributor.article.getFeatureValueById(28)
    if (dnDistributor) dnDistributors[dnDistributor] += distributor.quantity
  })

  // get feature 28 and 29 of rule article
  const article = Article.query().where('id', rule.article_id).with(['features']).first()
  if (!article) return 0
  const feature28 = article.getFeatureValueById(28)
  const feature29 = article.getFeatureValueById(29)
  // if feature 29 is not equal to dn return 0
  if (feature29 != dn) return 0
  let quantity = 0
  // if dnDistributors[feature28] is greater than 0 return dnDistributors[feature28] else return 0
  return dnDistributors[feature28] > 0 ? dnDistributors[feature28] : 0
}

export function getRoomQuantity(rule, room, accessorygroupId) {
  if (!rule.json) {
    return rule.value
  }
  if (rule.json.article) {
    let article = Article.query().where('id', rule.json.article).with(['accessorygroup']).first()
    if (!article) return 0
    const connectedArticle = StoredRoomArticle.query()
      .where('room_id', room.id)
      .where('accessorygroup_id', article.getAccessorygroupId([accessorygroupId]))
      .where('article_id', rule.json.article)
      .first()

    if (!connectedArticle) return 0
    return connectedArticle.quantity
  }
  if (rule.json.condition) {
    return roomQuantityConditions(rule, room)
  }
  if (rule.json.ltms) {
    const unit = Unit.find(room.unitId)
    if (!unit) return 0
    if (rule.json.ltms.includes(unit.ventilationMeasure)) return rule.value
  }
  return 0
}

function roomQuantityConditions(rule, room) {
  switch (rule.json.condition) {
    case 'valve':
      return valveCondition(rule, room)
    case 'ec45':
    case 'ec60':
      return roomDeviceConditions(rule, room)
    case 'elsEquipment':
      return elsEquipmentCondition(rule, room)
  }
}

function valveCondition(rule, room) {
  let valve = Valve.query().where('roomId', room.id).first()
  if (!valve) return 0
  let systemselection = Systemselection.query().where('unitId', room.unitId).first()

  let pipeProfile = 75
  if (systemselection.pipeProfile == 2) {
    pipeProfile = 63
  } else if (valve.pipesystem == 2) {
    pipeProfile = 51
  }
  if (!rule.json.features) {
    return Valve.query().where('roomId', room.id).get().length
  }
  const hasFeature39 = rule.json.features.some((feature) => feature.id == 39 && feature.value == valve.valvesPosition)
  const hasFeature12 = rule.json.features.some((feature) => feature.id == 12 && feature.value == pipeProfile)
  if (!hasFeature39 || !hasFeature12) return 0
  return Valve.query().where('roomId', room.id).get().length
}

function roomDeviceConditions(rule, room) {
  // Get Device from Store
  const device = StoredRoomArticle.query()
    .where('room_id', room.id)
    .where('accessorygroup_id', 1)
    .where('quantity', (quantity) => quantity >= 1)
    .with(['article.features'])
    .first()

  if (!device) return 0
  // Get Device quantity multiply with rule value and return
  return device.quantity * rule.value
}

function elsEquipmentCondition(rule, room) {
  // Get Room mountingPosition
  const mountingPosition = room.mountingPosition
  // check if rule.json.features has feature 46 with value mountingPosition then return rule.json.features[x].quantity
  if (rule.json.features) {
    const feature = rule.json.features.find((feature) => feature.id == 46 && feature.value == mountingPosition)
    if (feature) return feature.quantity
  }
  return 0
}

function controllingComboCondition(rule, unitId) {
  let controllingCombos = {}
  // Get Stored Controlling Combos from Store
  if (checkControllingCombo(unitId, rule.article_id)) {
    controllingCombos = store.state.controllingCombo.storedControllingCombos
  } else {
    return 0
  }
  // Get Controlling Combo from storedControllingCombos
  const controllingCombo = controllingCombos[unitId]

  // Return quantity of controllingCombo, if value 1 primary, if value 2 secondary
  if (rule.value == 1) {
    return controllingCombo.primary
  } else if (rule.value == 2) {
    return controllingCombo.secondary
  } else {
    return 0
  }
}

function ec60DeviceCondition(rule, roomId) {
  // Get Room with airvolume
  const room = Room.query().where('id', roomId).with(['airvolume']).first()
  if (!room) return 0
  // Return airvolume / 60
  return Math.ceil(parseFloat(room.airvolume.airvolume) / 60)
}

function ec45DeviceCondition(rule, roomId) {
  // Get Room with airvolume
  const room = Room.query().where('id', roomId).with(['airvolume']).first()
  if (!room) return 0
  // If airType is 1 return 2, if airType is 2 return airvolume / 22.5
  if (room.airType == 1) {
    return 2
  } else if (room.airType == 2) {
    return Math.ceil(parseFloat(room.airvolume.airvolume) / 22.5)
  } else {
    return 0
  }
}

function getStoredArticle(articleId, unitRoomId, accessorygroupId, withQuantity = false) {
  if (storeType == 'unit') {
    if (withQuantity) {
      return StoredArticle.query()
        .where('article_id', articleId)
        .where('unit_id', unitRoomId)
        .where('accessorygroup_id', accessorygroupId)
        .where('quantity', (quantity) => quantity >= 1)
        .first()
    } else {
      return StoredArticle.query().where('article_id', articleId).where('unit_id', unitRoomId).where('accessorygroup_id', accessorygroupId).first()
    }
  }
  if (storeType == 'room') {
    if (withQuantity) {
      return StoredRoomArticle.query()
        .where('article_id', articleId)
        .where('room_id', unitRoomId)
        .where('accessorygroup_id', accessorygroupId)
        .where('quantity', (quantity) => quantity >= 1)
        .first()
    } else {
      return StoredRoomArticle.query().where('article_id', articleId).where('room_id', unitRoomId).where('accessorygroup_id', accessorygroupId).first()
    }
  }
}
